<div class="login-container">
    <div class="background">
        <div class="shape"></div>
        <div class="shape"></div>
    </div>
    <form [formGroup]="resetPasswordForm" (ngSubmit)="submitResetPassword()" novalidate>


        <div class="form-group text-center" *ngIf="!emailSent; else emailSentBlock">
            <label class="mb-4">Enter a new password</label>
            <input type="password" class="form-control" formControlName="password" placeholder="Password" required>
        </div>

        <div class="form-group text-center" *ngIf="!emailSent; else emailSentBlock">
            <input type="password" class="form-control" formControlName="confirmPassword" required placeholder="Confirm Password">
        </div>

        <ng-template #emailSentBlock>
            <div class="email-success text-center">
                link has been sent succesfully, please check your inbox.
            </div>
        </ng-template>

        <button type="submit" *ngIf="!emailSent" >Reset</button>
    </form>
</div>